<template>
  <div ref="whole_page" id="whole_page "> 
    <vx-card id="addShortCourseBundle" :title="'Add Bundle'" class="w-full mb-6">
      <div class="short-course-content">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-col w-full mb-3">
              <label>Name</label>
              <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Name" v-model="formData.name" />
              <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
            </div>

            <div class="vx-col w-full">
              <label>Description</label>
              <vs-textarea autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Description" v-model="formData.description" />
              <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
            </div>

            <div class="vx-row w-full">
              <div class="vx-col sm:w-1/3 w-full">
                <label>Hours</label>
                <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Hours" v-model="bundleHours" />
                <span class="text-danger text-sm" v-show="errors.has('Hours')">{{ errors.first('Hours') }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <label>Calculated Value</label>
                <vs-input type="number" autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Price" v-model="bundleValue" />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <label>Price</label>
                <vs-input type="number" autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Price" v-model="formData.price" />
                <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
              </div>
              <div class="vx-col mt-4 sm:w-1/2 w-full">
                <vs-checkbox v-model="formData.isAccredited">Accredited</vs-checkbox>
              </div>
            </div>

          </div>

          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-col w-full">
              <label>Logo</label>
              <file-pond
                v-if="!formData.logoUrl"
                id="filepond"
                ref="Logopond"
                :server="uploadLocation"
                :name="'file'"
                label-idle="Drop Bundle logo here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="image/*,"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="false"
                @processfile="uploadComplete"
                @removefile="fileRemoved"
              />
              <vx-card class="logoCard w-full mb-2" v-if="formData.logoUrl" >
                <div class="vx-row">
                  <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(formData.logoUrl)}}</p>
                  <vs-spacer></vs-spacer>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('logoUrl')"></vs-button>
                </div>
              </vx-card>
            </div>
            <div class="vx-col w-full">
              <label>Video</label>
              <file-pond
                v-if="!formData.videoUrl"
                id="videofilepond"
                ref="Videopond"
                :server="uploadLocation"
                :name="'file'"
                label-idle="Drop Bundle Intro Video here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="video/*,"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="false"
                @processfile="videoUploadComplete"
                @removefile="fileRemoved"
              />
              <vx-card class="logoCard w-full mb-2" v-if="formData.videoUrl" >
                <div class="vx-row">
                  <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedVideoName(formData.videoUrl)}}</p>
                  <vs-spacer></vs-spacer>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('videoUrl')"></vs-button>
                </div>
              </vx-card>
            </div>

            <div class="vx-col w-full">
              <label>Document</label>
              <file-pond
                v-if="!formData.documentUrl"
                id="documentfilepond"
                ref="Documentpond"
                :server="uploadLocation"
                :name="'file'"
                label-idle="Drop Bundle Document here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="application/pdf,"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="false"
                @processfile="documentUploadComplete"
                @removefile="fileRemoved"
              />
              <vx-card class="logoCard w-full mb-2" v-if="formData.documentUrl" >
                <div class="vx-row">
                  <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(formData.documentUrl)}}</p>
                  <vs-spacer></vs-spacer>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('documentUrl')"></vs-button>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div class="vx-row pb-3">
        </div>
        <div class="vx-row pb-3">
        </div>
      </div>

      <template>
        <vx-card :title="'Assign Shortcourse to Bundle'" class="w-full mb-6">
          <b-row>
            <b-col
              md="2"
              sm="4"
              class="my-1"
            >
              <b-form-group
                class="mb-0"
              >
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="tasksPerPage"
                  size="sm"
                  :options="pageOptions"
                  class="w-50"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col
              md="4"
              sm="8"
              class="my-1"
            >
              <b-form-group
                label="Sort"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="sortBySelect"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-select
                    id="sortBySelect"
                    v-model="sortBy"
                    :options="sortOptions"
                    class="w-75"
                  >
                    <template v-slot:first>
                      <option value="">
                        -- none --
                      </option>
                    </template>
                  </b-form-select>
                  <b-form-select
                    v-model="sortDesc"
                    size="sm"
                    :disabled="!sortBy"
                    class="w-25"
                  >
                    <option :value="false">
                      Asc
                    </option>
                    <option :value="true">
                      Desc
                    </option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col> -->
            <!-- <b-col
              md="6"
              class="my-1"
            >
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col> -->

            <b-col cols="12">
              <b-table
                striped
                hover
                responsive
                :per-page="tasksPerPage"
                :current-page="currentTaskPage"
                :items="notAssisgnedShortCourses"
                :fields="unassignedTableFields"
                class="mt-3 vs-con-loading__container"
              >
              <!-- :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered" -->
                <!-- A virtual column -->
                <template #cell(name)="data">
                  {{ data.item.name}}
                </template>

                <!-- A custom formatted column -->
                <template #cell(hours)="data">
                  {{ data.item.hours }}
                </template>

                <!-- A custom formatted column -->
                <template #cell(price)="data">
                  R{{data.item.price}}
                </template>

                <template #cell(accredited)="data">
                  <i :class="data.item.isAccredited ? 'icon feather icon-check' : 'icon feather icon-x'"></i>
                </template>

                <template #cell(assign_to_bundle)="data">
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignCourse(data.item.id)"></vs-button>
                </template>
              </b-table>
            </b-col>

            <b-col
              cols="12"
            >
              <b-pagination
                v-model="currentTaskPage"
                :total-rows="totalRows"
                :per-page="tasksPerPage"
                align="center"
                size="sm"
                class="my-0"
              />
            </b-col>
            
          </b-row>
        </vx-card>
      </template>

      <template>
        <vx-card :title="'Assigned Shortcourses'" class="w-full mb-6">
          <b-row style="display: flex; justify-content: flex-end;">
            <vs-button color="success" @click="clearPrerequisites()" type="filled" >Clear prerequisites</vs-button>
          </b-row>
          <b-row>
            <!-- <b-col
              md="2"
              sm="4"
              class="my-1"
            >
              <b-form-group
                class="mb-0"
              >
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="tasksPerPage"
                  size="sm"
                  :options="pageOptions"
                  class="w-50"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              sm="8"
              class="my-1"
            >
              <b-form-group
                label="Sort"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="sortBySelect"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-select
                    id="sortBySelect"
                    v-model="sortBy"
                    :options="sortOptions"
                    class="w-75"
                  >
                    <template v-slot:first>
                      <option value="">
                        -- none --
                      </option>
                    </template>
                  </b-form-select>
                  <b-form-select
                    v-model="sortDesc"
                    size="sm"
                    :disabled="!sortBy"
                    class="w-25"
                  >
                    <option :value="false">
                      Asc
                    </option>
                    <option :value="true">
                      Desc
                    </option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              class="my-1"
            >
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col> -->

            <b-col cols="12">
              <b-table
                striped
                hover
                responsive
                :per-page="tasksPerPage"
                :current-page="currentTaskPage"
                :items="assignedShortCourses"
                :fields="tableFields"
                class="mt-3 vs-con-loading__container"
              >
              <!-- :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered" -->
                <!-- A virtual column -->
                <template #cell(name)="data">
                  {{ data.item.name}}
                </template>

                <!-- A custom formatted column -->
                <template #cell(hours)="data">
                  {{ data.item.hours }}
                </template>

                <!-- A custom formatted column -->
                <template #cell(price)="data">
                  R{{data.item.price}}
                </template>

                <template #cell(accredited)="data">
                  <i :class="data.item.isAccredited ? 'icon feather icon-check' : 'icon feather icon-x'"></i>
                </template>


                <template #cell(unassign_to_bundle)="data">
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-minus" @click.stop.prevent="unassignCourse(data.item.id)"></vs-button>
                </template>

                
                <template #cell(prerequisite)="data">
                  <b-form-select
                    v-model="data.item.prerequisiteShortCourseId"
                    :options="selectedShortCourses"
                  />
                </template>

                <template #cell(number)="data">
                  <div class="flex">
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="right" :disabled="data.item.number == 0"  icon="icon-arrow-up" @click="moveIndexUp(data.index)"></vs-button>
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="left" :disabled="getLastIndex(data.item.number)" icon="icon-arrow-down" @click="moveIndexDown(data.index)"></vs-button>
                  </div>
                </template>
              </b-table>
            </b-col>

            <b-col
              cols="12"
            >
              <b-pagination
                v-model="currentTaskPage"
                :total-rows="totalRows"
                :per-page="tasksPerPage"
                align="center"
                size="sm"
                class="my-0"
              />
            </b-col>
            
          </b-row>
        </vx-card>
      </template>

      <div class="flex buttonArea w-full justify">
        <vs-button color="success" @click="saveBundle()" type="filled" >Save</vs-button>
        <vs-button color="warning" type="border" class="ml-3" @click="cancelAdd" >cancel</vs-button>
      </div>
    </vx-card>
    
  </div>
</template> 


<script>

import {
  BTable, BFormGroup, BFormRadio, BFormCheckbox, BFormRadioGroup, BCardBody,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import vueFilePond, {setOptions } from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  data() {
    return {
      tableFields:['name','hours','price','accredited','unassign_to_bundle','prerequisite','number'], 
      unassignedTableFields : ['name','hours','price','accredited','assign_to_bundle'], 
      tasksPerPage:10,
      currentTaskPage:1,
      pageOptions: [10, 20, 30],
      totalRows:1,
      shortCourses:[],
      assignedShortCourses:[],
      notAssisgnedShortCourses:[],
      selectedShortCourses:[],
      bundleName:"",
      formData:{
          id:0,
          name:"",
          description:"",
          hours:0,
          price:0,
          logoUrl:"",
          videoUrl:"",
          documentUrl:"",
          isAccredited:false,
        },
      addBundleView:false,
      updateBundleView:false,
    }
  },
  components:{ 
    vSelect,
    BTable,
    BFormGroup,
    BCardBody,
    vSelect,
    BFormRadio,
    BFormCheckbox,
    BFormRadioGroup,
  },
  watch:{ 
    assignedShortCourses: function(){
      var self = this;
      if(self.shortCourses){
        self.getSelectListPrerequisite();
      }
    }
  },
  computed: {
    server(){
      return {
        url: 'https://content.digicampus.co.za/scripts/',
        process: {
          url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
        },
      };
    }, 
    uploadLocation:{
        get() {
        return this.$buildUrl("tempupload");
      }
    },
    bundleHours:{
      get(){
        var self = this;
        var hours = 0;
        self.assignedShortCourses.forEach(element => {
          hours+= element.hours;
        });
        return hours;
      }
    },
    bundleValue:{
      get(){
        var self = this;
        var calculated = 0;
        self.assignedShortCourses.forEach(element => {
          calculated+= element.price;
        });
        return calculated;
      }
    }
  },
  methods: { 
    initValues(){
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.hours = "";
      this.formData.price = "";
      this.formData.logoUrl = "";
      this.formData.videoUrl = "";
      this.formData.documentUrl = "";
      this.formData.isAccredited = false;
      this.moduleName = false;
      this.shortCourseList = [];
      this.tasksPerPage = 10;
      this.currentTaskPage = 1;
      this.updateBundleView = false;
      this.errors.clear();
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    cancelAdd(){
      this.addBundleView = false;
      this.initValues();
      this.getShortCourses();
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.logoUrl = response.url;
      this.clearFilepond("Logopond")
    },
    documentUploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.documentUrl = response.url;
      this.clearFilepond("Logopond")
    },
    videoUploadComplete(error, file) {
      if(file.serverId)
        this.formData.videoUrl = file.serverId;
      this.clearFilepond("videoUrl")
    },
    fileRemoved(error, file) {
      this.formData.logoUrl = null;
    },
    clearFilepond(reference){
      var self = this;
      if(this.$refs[reference]){
        self.$refs[reference].getFiles().forEach(element => {
          self.$refs[reference].removeFile(element);
        });
      }
    },
    uploadedFileName(name){
      var self = this;
      if(name){
        var size = name.length;
        var firstIndex = name.split("_")[0].length +1;
        var file = name.substring(firstIndex,size);
        return file
      }
      else{
        return name
      }
    },
    uploadedVideoName(name){
      var self = this;
      if(name){
        var size = name.length;
        var firstIndex = name.split("g/")[0].length +2;
        var file = name.substring(firstIndex,size);
        return file
      }
      else{
        return name
      }
    },
    removeFileButton(file){
      var self = this;
      self.formData[file] = "";
      self.$vs.notify({
        title:'Information',
        color: "warning",
        text: "File Removed",
        position:'top-right',
        iconPack: 'feather',
        icon:'icon-trash',
      });
    },
    getShortCourses(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.shortCourses = response.data;
        self.notAssisgnedShortCourses = self.shortCourses;
        this.totalRows = response.data.length
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, "ShortCourse/ListShortCourses" , onSuccess, onFinally);
    },
    saveBundle(){
      var self = this;
      self.$validator.validateAll().then(result => {
        if(result){
          self.sendBundle();
        }
        else{
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
          return;
        }
      });
    },
    sendBundle(){
      var self = this;
      var objectToSend = {
        id:0,
        bundleInformation:{
          name:self.formData.name,
          description:self.formData.description,
          hours:self.bundleHours,
          price:self.formData.price,
          logoUrl:self.formData.logoUrl,
          videoUrl:self.formData.videoUrl,
          documentUrl:self.formData.documentUrl,
          isAccredited:self.formData.isAccredited,
        },
        shortCourses:[

        ]
      };
      
      self.assignedShortCourses.forEach(element => {
        var courseObjectToAdd = {
          shortCourseId:element.id,
          number:element.number,
          prerequisiteShortCourseId:element.prerequisiteShortCourseId
        }
        objectToSend.shortCourses.push(courseObjectToAdd);
      });

      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Bundle Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
        self.$router.push({ name: 'ShortCourseBundles'});
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
      self.$ajaxPost(self, "Bundles/AddBundle" , objectToSend , onSuccess, onFinally);
    },
    getSelectListPrerequisite(){
      var self = this;
      var preRequisiteSelectList = [];
      preRequisiteSelectList.push({value:"0",text:"None"})
      self.assignedShortCourses.forEach(element => {
        preRequisiteSelectList.push({value:String(element.id),text:element.name})
      });
      self.selectedShortCourses = preRequisiteSelectList;
    },
    assignCourse(id){
      var self = this;
      var course = self.shortCourses.filter(q=> q.id == id)[0];

      if(!self.assignedShortCourses.length){
        course.number = 0;
        self.assignedShortCourses.push(course);
      }else{
        self.assignedShortCourses.sort((a,b) => a.number - b.number);
        course.number = self.assignedShortCourses[self.assignedShortCourses.length - 1].number + 1;
        self.assignedShortCourses.push(course);
      }
      
      self.notAssisgnedShortCourses = self.shortCourses.filter(q=> !self.assignedShortCourses.includes(q));
    },
    unassignCourse(id){
      var self = this;
      self.assignedShortCourses = self.assignedShortCourses.filter(q=> q.id != id);
      self.notAssisgnedShortCourses = self.shortCourses.filter(q=> !self.assignedShortCourses.includes(q));
      self.notAssisgnedShortCourses.forEach(q=> q.number = null);
    },
    clearPrerequisites(){
      var self = this;
      self.shortCourses.forEach(element => {
        element.prerequisiteShortCourseId = null;
      });
    },
    moveIndexUp(index){
      var self = this;
      if(index == 0){
        return;
      }
      var upperCourse = self.assignedShortCourses[index -1];
      var course = self.assignedShortCourses[index];
      course.number = course.number -1;
      upperCourse.number = upperCourse.number+1;

      self.assignedShortCourses.sort((a,b) => a.number - b.number);
    },
    moveIndexDown(index){
      var self = this;
      if(self.getLastIndex(index)){
        return;
      }
      var lowerCourse = self.assignedShortCourses[index +1];
      var course = self.assignedShortCourses[index];
      course.number = course.number +1;
      lowerCourse.number = lowerCourse.number-1;

      self.assignedShortCourses.sort((a,b) => a.number - b.number);
    },
    getLastIndex(index){
      var self = this;
      
      if(self.assignedShortCourses[self.assignedShortCourses.length - 1].number == index){
        return true;
      }
      return false;
    }
  },
  mounted() { 
    var self = this;
    self.initValues();
    self.getShortCourses();
  },
}
</script>


<style lang="scss"> 

</style>